import { Page } from "src/components/page"

import ChatMessages from "./messages"
import ChatHeader from "./header"

export default function Chat() {
  return (
    <Page className="flex flex-col h-[calc(100svh-4rem)] sm:h-[calc(100svh-7rem)] lg:h-[calc(100svh-3rem)]">
      <ChatHeader />
      <ChatMessages />
    </Page>
  )
}
